import React, { useState } from 'react'
import ProjectProgressBar from '../ProjectProgressBar'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import { Card } from '@material-ui/core'

const ProjectStatusInfo = styled.div`
  position: relative;
  z-index: 9999;
`
const InfoCard = styled(Card)`
  position: absolute;
  top: 12px;
  width: 210px;
  padding: 8px 16px 16px 20px;
`

const Status = styled.div`
  border-left: 1px solid var(--color-light-gray);
  padding: 0 0 20px 12px;
  position: relative;

  .status {
    margin-top: -8px;
  }

  &:before {
    content: '';
    position: absolute;
    width: 9px;
    height: 9px;
    background: var(--color-primary);
    border-radius: 50%;
    left: -5px;
    top: 4px;
  }

  &.current {
    &:before {
      box-shadow: 0px 0px 0px 1px white inset;
      border: 1px solid var(--color-primary);
    }
  }

  &.next {
    color: #cacaca;

    &:before {
      background: var(--color-light-gray);
    }
  }

  &:first-of-type {
    margin-top: 16px;

    &:after {
      content: '';
      position: absolute;
      width: 9px;
      height: 9px;
      background: white;
      left: -5px;
      top: -5px;
    }
  }

  &:last-of-type {
    border-left: 1px solid transparent;
    padding-bottom: 0;
  }
`

const statuses = [
  { status: 'New', description: 'Customer has not yet submitted project' },
  {
    status: 'Submitted for review',
    description: 'AE reviewing project details',
  },
  {
    status: 'Quote submitted',
    description: 'Customer must sign project quote',
  },
  {
    status: 'In progress',
    description: 'AE is working on the request',
  },
  {
    status: 'Pending acceptance',
    description: 'Awaiting customer deliverables approval',
  },
  { status: 'Complete', description: 'Project is complete' },
]

const ProjectStatusBar = (props) => {
  const { project } = useSelector((state) => state.projectDetails)

  const [visible, setVisible] = useState(false)

  const dotType = (index) => {
    let num

    switch (project.status) {
      case 'New':
        num = 0
        break
      case 'Submitted for review':
        num = 1
        break
      case 'Quote submitted':
        num = 2
        break
      case 'In progress':
        num = 3
        break
      case 'Pending acceptance':
        num = 4
        break
      case 'Complete':
        num = 5
        break
      default:
        num = 0
    }

    return index < num ? 'completed' : index === num ? 'current' : 'next'
  }

  return (
    <>
      {visible && (
        <ProjectStatusInfo>
          <InfoCard>
            {statuses.map((x, index) => (
              <Status key={index} className={dotType(index)}>
                <div className="fs12 bold status">{x.status}</div>
                <div className="fs10">{x.description}</div>
              </Status>
            ))}
          </InfoCard>
        </ProjectStatusInfo>
      )}

      <ProjectProgressBar
        project={project}
        className={`m-r-24 hide-991 relative ${
          project.status === 'Archived' ? 'gray' : ''
        }`}
        onMouseOver={() => setVisible(true)}
        onMouseOut={() => setVisible(false)}
      />
    </>
  )
}
export default ProjectStatusBar
